import { MANUAL, SHURJO_PAY, SSLCOMMERZ, STRIPE } from "@/helpers/constant/companyPaymentMethod";
import {
  SUBSCRIPTION_ACCESS,
  PRICING_TABLE_ACCESS,
  SUBSCRIPTION_EDIT,
  PAYMENT_HISTORY_ACCESS,
} from "@/helpers/permissionsConstant";
import store from "@/store";
const paymentMethod = store.getters["paymentMethodModule/getPaymentMethod"];

const stripePages = [
  {
    path: "/pricing",
    name: "pricing-table",
    component: () => import("@/views/admin/payment/stripe/Subscription.vue"),
    meta: {
      gate: PRICING_TABLE_ACCESS,
      requiresAuth: true,
      pageTitle: "Pricing Tables",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Pricing Tables",
          active: true,
          to: "",
        },
      ],
    },
  },
  {
    path: "/payment-histories",
    name: "payment-histories",
    component: () =>
      import("@/views/admin/payment/stripe/PaymentHistoriesView.vue"),
    meta: {
      gate: PAYMENT_HISTORY_ACCESS,
      requiresAuth: true,
      pageTitle: "Payment Histories",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Payment Histories",
          active: true,
          to: "",
        },
      ],
    },
  },
];


const sslCommerzPages = [
  {
    path: "/pricing",
    name: "pricing-table",
    component: () => import("@/views/admin/payment/sslCommerz/Subscription.vue"),
    meta: {
      gate: PRICING_TABLE_ACCESS,
      requiresAuth: true,
      pageTitle: "Pricing Tables",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Pricing Tables",
          active: true,
          to: "",
        },
      ],
    },
  },
  {
    path: "/payment-histories",
    name: "payment-histories",
    component: () =>
      import("@/views/admin/payment/sslCommerz/PaymentHistoriesView.vue"),
    meta: {
      gate: PAYMENT_HISTORY_ACCESS,
      requiresAuth: true,
      pageTitle: "Payment Histories",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Payment Histories",
          active: true,
          to: "",
        },
      ],
    },
  },
];



const manualPaymentPages = [
  {
    path: "/pricing",
    name: "pricing-table",
    component: () => import("@/views/admin/payment/manual-payment/Subscription.vue"),
    meta: {
      gate: PRICING_TABLE_ACCESS,
      requiresAuth: true,
      pageTitle: "Pricing Tables",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Pricing Tables",
          active: true,
          to: "",
        },
      ],
    },
  },
  {
    path: "/payment-histories",
    name: "payment-histories",
    component: () =>
      import("@/views/admin/payment/manual-payment/PaymentHistoriesView.vue"),
    meta: {
      gate: PAYMENT_HISTORY_ACCESS,
      requiresAuth: true,
      pageTitle: "Payment Histories",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Payment Histories",
          active: true,
          to: "",
        },
      ],
    },
  },
];

const shurjoPaymentPages = [
  {
    path: "/pricing",
    name: "pricing-table",
    component: () => import("@/views/admin/payment/shurjopay/Subscription.vue"),
    meta: {
      gate: PRICING_TABLE_ACCESS,
      requiresAuth: true,
      pageTitle: "Pricing Tables",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Pricing Tables",
          active: true,
          to: "",
        },
      ],
    },
  },
  {
    path: "/payment-histories",
    name: "payment-histories",
    component: () =>
      import("@/views/admin/payment/shurjopay/PaymentHistoriesView.vue"),
    meta: {
      gate: PAYMENT_HISTORY_ACCESS,
      requiresAuth: true,
      pageTitle: "Payment Histories",
      homePatch: "/admin/dashboard",
      breadcrumb: [
        {
          text: "Payment Histories",
          active: true,
          to: "",
        },
      ],
    },
  },
];

let filteredPages = [];

if (paymentMethod === STRIPE) {
  filteredPages = stripePages;
} else if (paymentMethod === SSLCOMMERZ) {
  filteredPages = sslCommerzPages;
} else if (paymentMethod === MANUAL) {
  filteredPages = manualPaymentPages;
} else if (paymentMethod === SHURJO_PAY) {
  filteredPages = shurjoPaymentPages;
}

export default [
  ...filteredPages,
];
